import { useNavigate } from 'react-router-dom'

const styles = `
body{
    margin:0;
    font-family:'Open Sans',sans-serif;
    background:#f7f8fc;
}

.destination-hero{
    background:#1a2e6e;
    color:white;
    padding:80px 20px;
}

.destination-container{
    max-width:1100px;
    margin:auto;
}

.destination-hero h1{
    font-size:46px;
    margin-bottom:15px;
    font-family:'Nunito',sans-serif;
}

.destination-hero p{
    font-size:18px;
    max-width:720px;
    opacity:.95;
    line-height:1.8;
}

.destination-content{
    max-width:1000px;
    margin:50px auto;
    background:white;
    border-radius:16px;
    padding:45px;
    box-shadow:0 10px 30px rgba(0,0,0,.08);
}

.destination-content h2{
    color:#1a2e6e;
    margin-top:40px;
    margin-bottom:20px;
    font-size:30px;
}

.destination-content h3{
    color:#1a2e6e;
    margin-bottom:15px;
}

.destination-content p{
    line-height:1.9;
    color:#555;
}

.destination-content li{
    margin-bottom:15px;
    line-height:1.8;
}

.highlight{
    background:#eef8f2;
    border-left:6px solid #39b36a;
    padding:25px;
    border-radius:12px;
    margin-top:35px;
}

.process{
    background:#f5f7fb;
    border:1px solid #d8dfef;
    padding:20px;
    border-radius:12px;
    text-align:center;
    font-weight:700;
    color:#1a2e6e;
    margin:25px 0;
}

.back-btn{
    background:#f5a623;
    color:white;
    border:none;
    padding:12px 24px;
    border-radius:8px;
    cursor:pointer;
    font-weight:700;
    margin-bottom:30px;
}

.back-btn:hover{
    opacity:.9;
}

@media(max-width:768px){

.destination-hero{
    padding:55px 20px;
}

.destination-hero h1{
    font-size:34px;
}

.destination-content{
    margin:20px;
    padding:25px;
}

}
`

export default function AustraliaDestination() {
  const navigate = useNavigate()

  return (
    <>
      <style>{styles}</style>

      <section className="destination-hero">
        <div className="destination-container">
          <button className="back-btn" onClick={() => navigate('/', { state: { scrollTo: 'study-destinations' } })}>
            ← Back
          </button>

          <h1>🇦🇺 Australia</h1>

          <p>
            Study with globally respected universities, enjoy a strong quality of life, and build your future in
            <strong> Australia</strong> through flexible work rights and clear post-study pathways.
          </p>
        </div>
      </section>

      <div className="destination-content">
        <h2>🌟 Why Choose Australia for Your Degree?</h2>

        <ul>
          <li>
            <strong>Top-Ranked Group of Eight (Go8) Universities:</strong> Access high-impact research, innovation, and industry-partnered degrees.
          </li>

          <li>
            <strong>Temporary Graduate Visa (Subclass 485):</strong> Generous post-study work rights allowing 2 to 4 years of employment post-graduation.
          </li>

          <li>
            <strong>High Standard of Living & Safety:</strong> Student-friendly cities like Melbourne, Sydney, and Brisbane consistently rank among the safest in the world.
          </li>

          <li>
            <strong>Flexible Work Opportunities:</strong> Part-time work permitted during study terms (up to 48 hours per fortnight) and full-time during breaks.
          </li>
        </ul>

        <h2>📋 Essential Checklist: Documents You Need</h2>

        <ul>
          <li>
            <strong>Passport:</strong> Valid passport covering your intended study period.
          </li>

          <li>
            <strong>Academic Documents:</strong> Transcripts and certificates verified by education boards or universities.
          </li>

          <li>
            <strong>English Test Score Report:</strong> IELTS Academic, PTE Academic, or TOEFL iBT results.
          </li>

          <li>
            <strong>Genuine Student (GS) Statement:</strong> Comprehensive essay detailing academic trajectory, career plans, and economic ties to your home country.
          </li>

          <li>
            <strong>Financial Proof & Solvency:</strong> Verified bank statement, education loan approval, or sponsor financial proofs.
          </li>

          <li>
            <strong>Overseas Student Health Cover (OSHC):</strong> Mandatory medical insurance for the entire visa duration.
          </li>
        </ul>

        <h2>🚀 Application & Visa Process</h2>

        <div className="process">University Offer Letter → GS Assessment & Solvency Verification → eCoE Issuance → Subclass 500 Student Visa</div>

        <ol>
          <li>
            <strong>Submit Academic Portfolio:</strong> Secure an Offer Letter from your chosen Australian institution.
          </li>

          <li>
            <strong>GS Assessment & Fee Deposit:</strong> Submit GS questionnaire, financial papers, and pay tuition deposit for eCoE.
          </li>

          <li>
            <strong>Receive Electronic Confirmation of Enrolment (eCoE):</strong> Essential document required for Australian visa lodgment.
          </li>

          <li>
            <strong>Subclass 500 Visa Lodgment:</strong> Complete medical examination, upload documents, and submit visa application online.
          </li>
        </ol>

        <div className="highlight">
          <h3>🤝 How Study Buddy Steps In as Your Guide</h3>

          <ul>
            <li>
              <strong>Genuine Student (GS) Drafting Assistance:</strong> Guidance on drafting a strong GS statement meeting Department of Home Affairs guidelines.
            </li>

            <li>
              <strong>Financial Document Pre-Check:</strong> Strict verification of sponsor bank accounts, income tax records, and loan documents.
            </li>

            <li>
              <strong>OSHC Insurance Setup:</strong> Assistance in selecting health cover options required for visa approval.
            </li>

            <li>
              <strong>Post-Arrival Guidance:</strong> Assistance with tax file number (TFN) setup, student job searches, and city orientation.
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
